// CountDown Clock (vanilla)
// Ported from https://github.com/epiksel/countdown

// options.date is a wall-clock time "MM/DD/YYYY HH:MM[:SS]" in options.timeZone (an IANA zone,
// default America/New_York). It's resolved to a real instant using that zone's UTC offset on the
// target date itself, so daylight-saving changes and the visitor's own timezone don't shift it.
function countdownTimer(selector, options, callback) {
  var container = document.querySelector(selector);
  if (!container) return;

  var target = countdownTimer.zonedToInstant(options.date, options.timeZone || 'America/New_York');
  if (isNaN(target)) return;

  function currentDate() {
    return Date.now();
  }

  function pad(n) {
    return String(n).length >= 2 ? n : '0' + n;
  }

  // Zero the digits and hide the timer (its .timer wrapper, when there is one) once the sale has ended.
  function expire() {
    container.querySelectorAll('.days, .hours, .minutes, .seconds').forEach(function(el) {
      el.textContent = '00';
    });
    var timer = container.closest('.timer') || container;
    timer.hidden = true;
    timer.style.display = 'none';
  }

  function tick() {
    var difference = target - currentDate();

    if (difference < 0) {
      clearInterval(interval);
      expire();
      if (typeof callback === 'function') callback();
      return;
    }

    var day = 1000 * 60 * 60 * 24;
    var hour = 1000 * 60 * 60;
    var minute = 1000 * 60;
    var second = 1000;

    var days = Math.floor(difference / day);
    var hours = Math.floor((difference % day) / hour);
    var minutes = Math.floor((difference % hour) / minute);
    var seconds = Math.floor((difference % minute) / second);

    var daysEl = container.querySelector('.days');
    var hoursEl = container.querySelector('.hours');
    var minutesEl = container.querySelector('.minutes');
    var secondsEl = container.querySelector('.seconds');
    if (daysEl) daysEl.textContent = pad(days);
    if (hoursEl) hoursEl.textContent = pad(hours);
    if (minutesEl) minutesEl.textContent = pad(minutes);
    if (secondsEl) secondsEl.textContent = pad(seconds);
  }

  var interval = setInterval(tick, 1000);
  tick();
}

// UTC offset (ms) of timeZone at the given instant.
countdownTimer.zoneOffset = function(instant, timeZone) {
  var parts = {};
  new Intl.DateTimeFormat('en-US', {
    timeZone: timeZone,
    hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit'
  }).formatToParts(new Date(instant)).forEach(function(p) { parts[p.type] = p.value; });
  var asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
  return asUtc - Math.floor(instant / 1000) * 1000;
};

// "MM/DD/YYYY HH:MM[:SS]" in timeZone -> epoch ms, or NaN when unparseable.
countdownTimer.zonedToInstant = function(value, timeZone) {
  var m = /^\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*$/.exec(String(value));
  if (!m) return NaN;
  var wall = Date.UTC(+m[3], +m[1] - 1, +m[2], +m[4], +m[5], +(m[6] || 0));
  try {
    var instant = wall - countdownTimer.zoneOffset(wall, timeZone);
    // Re-check with the offset at the candidate instant, in case a DST change lies between the two.
    var offset = countdownTimer.zoneOffset(instant, timeZone);
    return wall - offset;
  } catch (e) {
    return NaN;
  }
};
